import { createSlice } from "@reduxjs/toolkit";
import { FetchUserDetails } from "./dashboardAction";

interface UserState {
  user: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  user: null,
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(FetchUserDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchUserDetails.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.user = payload.data; // Store full user details
      })
      .addCase(FetchUserDetails.rejected, (state, { payload }) => {
        state.loading = false;
        state.error =
          (payload as { responseMessage?: string })?.responseMessage || "Failed to fetch user details";
      });
  },
});

export const dashboardReducer = dashboardSlice.reducer;
